/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';

/**
 * Guard to redirect on invalid route.
 *
 * @param to
 * @param from
 * @param next
 */
export const notFoundGuard: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    if (!to.matched.length) {
        next('/');
        return;
    }

    next();
};
